import(/* webpackMode: "eager" */ "/Users/npits/Documents/npf/services/wb-site/shop/src/app/error.tsx")